import { sha256 as nobleSha256 } from "@noble/hashes/sha256";

export function sha256(data: Uint8Array): Uint8Array {
  return nobleSha256(data);
}

export function sha256Hex(data: Uint8Array): string {
  return Array.from(sha256(data))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
